export function isAbsolute(path: URL | Request | string): boolean {
	if (path instanceof URL) return true;
	if (path instanceof Request) return true;

	return path.indexOf('http://') === 0 || path.indexOf('https://') === 0;
}
